import * as Yup from 'yup';

import { Countries, KycFormFlag, NAME_REG_EXP, ZIP_CODE_REG_EXP } from './types';

export type KycFormFields = {
  isParticipate: string;
  isResident: string;
  externalTransactionId: string;
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  state: string;
  province: string;
  city: string;
  fullAddress: string;
  zipCode: string;
};

export const initialState: KycFormFields = {
  isParticipate: KycFormFlag.init,
  isResident: KycFormFlag.init,
  externalTransactionId: '',
  firstName: '',
  lastName: '',
  email: '',
  country: Countries.usa,
  state: '',
  province: '',
  city: '',
  fullAddress: '',
  zipCode: '',
};

export const validationSchema = Yup.object({
  isParticipate: Yup.string().notRequired(),
  isResident: Yup.string().notRequired(),
  externalTransactionId: Yup.string()
    .max(100, 'Maximum 100 symbols')
    .when('isParticipate', (_, schema, { parent }) => {
      const { isParticipate } = parent;
      return isParticipate === KycFormFlag.yes ? schema.required('This field is required') : schema.notRequired();
    }),
  firstName: Yup.string()
    .max(100, 'Maximum 100 symbols')
    .when('isResident', (_, schema, { parent }) => {
      const { isResident } = parent;
      return isResident === KycFormFlag.yes
        ? schema
            .required('This field is required')
            .test('firstName', 'Please enter a valid first name', (value) => NAME_REG_EXP.test(value || ''))
        : schema.notRequired();
    }),
  lastName: Yup.string()
    .max(100, 'Maximum 100 symbols')
    .when('isResident', (_, schema, { parent }) => {
      const { isResident } = parent;
      return isResident === KycFormFlag.yes
        ? schema
            .required('This field is required')
            .test('lastName', 'Please enter a valid last name', (value) => NAME_REG_EXP.test(value || ''))
        : schema.notRequired();
    }),
  email: Yup.string()
    .email()
    .when('isResident', (_, schema, { parent }) => {
      const { isResident } = parent;
      return isResident === KycFormFlag.yes ? schema.required('This field is required') : schema.notRequired();
    }),
  country: Yup.string()
    .max(100, 'Maximum 100 symbols')
    .when('isResident', (_, schema, { parent }) => {
      const { isResident } = parent;
      return isResident === KycFormFlag.yes ? schema.required('This field is required') : schema.notRequired();
    }),
  state: Yup.string()
    .max(100, 'Maximum 100 symbols')
    .when('isResident', (_, schema, { parent }) => {
      const { isResident, country } = parent;
      return isResident === KycFormFlag.yes && country === Countries.usa
        ? schema.required('This field is required')
        : schema.notRequired();
    }),
  province: Yup.string()
    .max(100, 'Maximum 100 symbols')
    .when('isResident', (_, schema, { parent }) => {
      const { isResident, country } = parent;
      return isResident === KycFormFlag.yes && country === Countries.canada
        ? schema.required('This field is required')
        : schema.notRequired();
    }),
  city: Yup.string()
    .max(100, 'Maximum 100 symbols')
    .when('isResident', (_, schema, { parent }) => {
      const { isResident } = parent;
      return isResident === KycFormFlag.yes ? schema.required('This field is required') : schema.notRequired();
    }),
  fullAddress: Yup.string()
    .max(100, 'Maximum 100 symbols')
    .when('isResident', (_, schema, { parent }) => {
      const { isResident } = parent;
      return isResident === KycFormFlag.yes ? schema.required('This field is required') : schema.notRequired();
    }),
  zipCode: Yup.string()
    .max(9, 'Maximum 9 symbols')
    .when('isResident', (_, schema, { parent }) => {
      const { isResident } = parent;
      return isResident === KycFormFlag.yes
        ? schema
            .required('This field is required')
            .test('zipCode', 'Please enter a valid zipCode', (value) => ZIP_CODE_REG_EXP.test(value || ''))
        : schema.notRequired();
    }),
});
